import React, { ReactNode, useState } from "react";
import { Tabs } from "@mantine/core";

type TabItems = {
  id: number;
  name: string;
  content: ReactNode;
  actions?: ReactNode[];
  filters?: ReactNode[];
};

type PageTabsProps = {
  tabs: TabItems[];
};

const PageTabs: React.FC<PageTabsProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState<TabItems>(tabs[0]);

  return (
    <Tabs
      styles={{ tabsList: { padding: "0 40px" }, body: { padding: 0 } }}
      active={activeTab.id}
      onTabChange={(value) => setActiveTab(tabs[value])}
    >
      {tabs.map((it) => (
        <Tabs.Tab key={`#tab-${it.name}`} label={it.name}>
          {it.content}
        </Tabs.Tab>
      ))}
    </Tabs>
  );
};

export default PageTabs;
